import {
  getExhibitionList,
  getExhibitionMallList,
  getBrandNameList,
  getCategoryNameList,
  getExhibitionMallDetails
} from '@/api/goods'
// import { setToken, removeToken } from '@/utils/auth'

const goods = {
  state: {
    conferenceId: '',
    brandId: '',
    goodsList: [],
    brandNameList: [],
    categoryNameList: []
  },
  mutations: {
    SET_EXHIBITION_LIST: (state, data) => {
      state.brandId = data.brandId
      state.conferenceId = data.conferenceId
    },
    SET_EXHIBITION_MALL_LIST: (state, data) => {
      if (data.page === 1) {
        let logoArr = [{
          'src': '',
          'href': '',
          'info': '',
          'logo': true
        }]
        logoArr = logoArr.concat(data.data)
        state.goodsList = logoArr
        // console.log(state.goodsList)
      } else {
        state.goodsList = state.goodsList.concat(data.data)
      }
      // console.log(data.page)
    },
    SET_BRAND_NAME_LIST: (state, data) => {
      state.brandNameList = data
    },
    SET_CATEGORY_NAME_LIST: (state, data) => {
      state.categoryNameList = data
    }
  },
  actions: {
    // 获取展厅列表数据
    GetExhibitionList ({ commit }, data) {
      return new Promise((resolve, reject) => {
        getExhibitionList(data).then(response => {
          // console.log(response)
          const data = response.dto
          // commit('SET_EXHIBITION_LIST', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取展厅页 - 商品列表
    GetExhibitionMallList ({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        getExhibitionMallList(dataParams).then(response => {
          // console.log(response)
          const data = response.dto
          commit('SET_EXHIBITION_MALL_LIST', {data: data, page: dataParams.page})
          // console.log(data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 展厅页品牌名称
    GetBrandNameList ({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        getBrandNameList(dataParams).then(response => {
          // console.log(response)
          const data = response.dto
          commit('SET_BRAND_NAME_LIST', data)
          // console.log(data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 展厅页类目名称
    GetCategoryNameList ({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        getCategoryNameList(dataParams).then(response => {
          // console.log(response)
          const data = response.dto
          commit('SET_CATEGORY_NAME_LIST', data)
          // console.log(data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 商品详情
    GetExhibitionMallDetails ({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        getExhibitionMallDetails(dataParams).then(response => {
          // console.log(response)
          const data = response.dto
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default goods



// WEBPACK FOOTER //
// ./src/store/modules/goods.js